import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import Copy from '../../components/cms/copy'
import Heading from '../../components/cms/heading'
import ModuleContainer from '../../components/cms/module-container'
import ProductAnimated from './product-animated'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import productAnimatedModuleRecipe from './index.recipe'

const ProductAnimatedModule = ({
    anchor,
    heading,
    headingLevel,
    copy,
    animatedProduct,
    containerHeight,
    background,
    desktopDisplay = 'product-below-copy'
}) => {
    const layout = desktopDisplay
    const {subline, headline1, headline2, variant} = heading
    const ariaLabel = `${subline} - ${headline1} ${headline2}`

    const recipe = useSlotRecipe({recipe: productAnimatedModuleRecipe})
    const styles = useMemo(() => {
        return recipe({layout})
    }, [layout, recipe])

    const alignment = {
        base: 'left',
        s: layout === 'side-by-side' ? 'left' : 'center'
    }

    return (
        <ModuleContainer
            anchor={anchor}
            bg={background}
            css={styles.container}
            aria-label={variant !== 'hidden' ? undefined : ariaLabel}
        >
            <Box css={styles.textBox}>
                <Box css={styles.textContent}>
                    <Heading headingLevel={headingLevel} {...heading} alignment={alignment} />
                    {copy?.text && <Copy {...copy} alignment={alignment}></Copy>}
                </Box>
            </Box>
            <Box css={styles.productBox}>
                <ProductAnimated {...animatedProduct} containerHeight={containerHeight} />
            </Box>
        </ModuleContainer>
    )
}

ProductAnimatedModule.propTypes = {
    anchor: PropTypes.string,
    headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
    heading: PropTypes.shape({
        headline1: PropTypes.string,
        headline2: PropTypes.string,
        subline: PropTypes.string,
        variant: PropTypes.string,
        alignment: PropTypes.oneOf(['left', 'center'])
    }),
    background: PropTypes.string,
    desktopDisplay: PropTypes.string,
    copy: PropTypes.shape({
        text: PropTypes.string,
        alignment: PropTypes.oneOf(['left', 'center'])
    }),
    animatedProduct: PropTypes.shape({
        imagePrefix: PropTypes.string,
        imageExtension: PropTypes.string,
        imageCount: PropTypes.number,
        imageWidth: PropTypes.number,
        imageHeight: PropTypes.number
    }),
    containerHeight: PropTypes.number
}

export default ProductAnimatedModule
